<template>

  <FattureTable />
 
</template>

<script>
import FattureTable from '../components/pratiche/TableFattureVendita.vue'

export default {
  components: {
    FattureTable

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

